<template>
  <div class="bottomcontain">
      <div class="left">
          <div>
              <img src="@/assets/topbar/logo.png"/>
          </div>
      </div>
      <div class="right">
          <div class="item">
              <div class="title">
                  {{getLan('c54355d2-36cc-469e-8817-a675ecbcf37f')}}
              </div>
              <div @click="jumpto('jumpintro')">
                  {{getLan('ed823948-04f1-4a22-84d1-22738f3c7b7d')}}
              </div>
              <div @click="jumpto('jumppro')">
                  {{getLan('b2b060c7-4861-4b19-bc17-956f5a990bc3')}}
              </div>
              <div @click="jumpto('jumpnews')">
                  {{getLan('06a21306-8d26-4ee2-a6c7-e8f41e59522e')}}
              </div>
              <div @click="jumpto('jumpteam')">
                  {{getLan('db102722-891a-413e-b01a-23fa6c07a6b2')}}
              </div>
          </div>
          <!-- <div class="item">
              <div class="title">
                  {{getLan('96cfe3d0-4dc0-43e3-8f9c-687ca67a1b0d')}}
              </div>
              <div @click="jumpto('jumppaint')">
                  {{getLan('9e5eb240-1e91-4d37-8434-f639d8c262b8')}}
              </div>
              <div @click="jumpto('jumppeace')">
                  Peace
              </div>
              <div @click="goPro">
                  {{getLan('a8b618d6-4463-418a-86b7-4b6c981a1236')}}
              </div>
          </div> -->
          <div class="item">
              <div class="title">
                  {{getLan('681c531f-c458-4fe0-8860-5c41cfef47cd')}}
              </div>
              <div @click="addUs">
                  {{getLan('c893bc9c-9ec0-4c95-9e52-1a22b9b482f6')}}
              </div>
              <div @click="addUs">
                  {{getLan('00aab6ea-267d-4089-aa31-88cc0e9fdf81')}}
              </div>
              <div @click="addUs">
                  {{getLan('d148d9d4-2a26-4ea9-a89f-c6691c760473')}}
              </div>
          </div>
          <div class="item">
              <div class="title">
                  {{getLan('17638e9f-eb46-4700-8adb-a973e253f361')}}
              </div>
              <div>
                  {{getLan('7c198b59-885a-4e19-a753-380d980243a4')}}
              </div>
              <div>
                  {{getLan('bad1964f-054d-468b-8055-9ced2629181b')}}
              </div>
          </div>
      </div>
        <div class="info" style="background: #F5F7F9;font-size:0.5rem;">
                <span style="color:#999;">© 2019 北京乐信圣文科技有限责任公司<a href="https://beian.miit.gov.cn/">京ICP备18001865号</a></span>
            <div style="width:300px;margin:0 auto; padding:20px 0;">
                <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802033640" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../assets/other/police.png" style="float:left;width: 20px; height: 20px"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#999;">京公网安备 11010802033640号</p></a>
            </div>
        </div>
  </div>
</template>

<script>
export default {
    methods: {
        jumpto(id) {
            if (document.querySelector(`#${id}`) === null) {
                location.href = '/'
                return
            }
            document.querySelector(`#${id}`).scrollIntoView()
        },
        goPro() {
            document.querySelector('#goPro').click()
        },
        addUs() {
            document.querySelector('#addus').click()
        }
    }
}
</script>

<style scoped>
.bottomcontain {
    width: 100rem;
    height: 15.45rem;
    background: #F5F7F9;
    position: relative;
    padding: 4.03rem 0rem 2.51rem 0rem;
    text-align: center;
    box-sizing: border-box;
}
.left {
    display: inline-block;
    margin-right: 6.23rem;
    text-align: left;
}
.left img {
    width: 6.75rem;
    height: 1.26rem;
}
.left .info {
    margin-top: 6.81rem;
    font-size: 0.84rem;
    font-weight: 300;
    color: #999999;
    line-height: 1.04rem;
}
.right {
    display: inline-block;
    vertical-align: top;
}
.right .item {
    display: inline-block;
    margin-right: 4rem;
    vertical-align: top;
    text-align: left;

}
.right div {
    font-size: 0.69rem;
    font-weight: 300;
    color: #999;
    line-height: 1.04rem;
    margin-bottom: 0.84rem;
    cursor: pointer;
}
.right .title {
    color: #333;
    font-weight: 400;
    cursor: text;
}
</style>


// WEBPACK FOOTER //
// src/components/BottomBar.vue